import { AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import { ConstantService } from '@app/_services/constant.service';
import 'ag-grid-enterprise';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-sales-by-property',
    templateUrl: './sales-by-property.component.html',
    styleUrls: ['./sales-by-property.component.css'],
    standalone: false
})
export class SalesByPropertyComponent implements OnInit, OnChanges {

	@Input() resRevByDay: any = [];
	@Input() resRevMaster: any = [];
	@Input() groupDefaultExpanded: any = 0;

	constructor(
		private router: Router,
		public messageService: MessageService,
		public reportService: ReportService,
		private constantService: ConstantService,) { }

	gridApi: GridApi;
	columnApi: ColumnApi;

	// ag-grid columns
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;


	autoGroupColumnDef = {
		headerName: 'Property',
		cellRendererParams: {
			suppressCount: true,
			// checkbox: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
		resizable: true,
		wrapHeaderText: true,
		autoHeaderHeight: true,
		minWidth: 110,
	};

	columnDefs: ColDef[] = [
		//Groups
		// { headerName: 'Property', field: 'propertyCode', rowGroup: true, hide: true},
		// { headerName: 'Development', field: 'developmentName', rowGroup: true, hide: true},
		// { headerName: 'Sale Year', field: 'saleYear', rowGroup: true, hide: true, valueGetter: this.getYearFromDate },
		// { headerName: 'Sale Month', field: 'saleMonth', rowGroup: true, hide: true, sortable: true, sort:'asc', valueGetter: this.getMonthFromDate,
		// 	comparator: (valueA, valueB) => {
		// 		const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
		// 			'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		// 		// sorts 'months' in chronological order
		// 		return months.indexOf(valueA) - months.indexOf(valueB);
		// 	},
		// },
		// { headerName: 'Sale Day', field: 'saleDayOfMonth', rowGroup: true, hide: true, sortable: true, sort: 'asc', comparator: (valueA, valueB, nodeA, nodeB, isDescending) => valueA - valueB },

		//Columns
		{ headerName: 'Sale Date', field: 'saleDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Location', field: 'locationId', sortable: true, sort: 'asc', cellRenderer: params => this.getLocationName(params) },
		{ headerName: 'Resort', field: 'developmentName', sortable: true, sort: 'asc' },
		{ headerName: 'Property', field: 'propertyCode', sortable: true },
		{ headerName: 'Order ID', field: 'orderId', sortable: true, sort: 'asc', hide: true },
		{ headerName: 'Nights', field: 'numNtsTTL', minWidth: 70, aggFunc: 'sum' },
		{ headerName: 'Arrival', field: 'checkInDate', aggFunc: 'showArrivalDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Departure', field: 'checkOutDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Revenue', field: 'revOwnerKBMTTL', aggFunc: 'sum', headerTooltip: 'Owner Amount + KBM Management Fee (ex-tax) — matches the Total Room Rate KPI',
			cellRenderer: (params: any) => params.data?._spacer ? '' : this.currencyCellRendererUSD({ value: Math.max(0, params.value || 0) }) },
		{ headerName: 'Rate', field: 'revOwnerKBMPNT', aggFunc: 'avg', headerTooltip: 'Owner Amount + KBM Management Fee per night — matches the Average Room Rate KPI',
			cellRenderer: (params: any) => params.data?._spacer ? '' : this.currencyCellRendererUSD({ value: Math.max(0, params.value || 0) }) },
		{ headerName: 'Guest Paid TTL', field: 'revGrossTTL', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum', headerTooltip: 'Total amount paid by guest including all fees' },
		{ headerName: 'Guest Paid PNT', field: 'revGrossPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum', headerTooltip: 'Total guest payment divided by number of nights' },
		{ headerName: 'Resort Fees PNT', field: 'resortFeePNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum', headerTooltip: 'Resort fee per night' },
		{ headerName: 'Damage Waiver Fees PNT', field: 'damageWaiverFeePNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum', headerTooltip: 'Damage waiver fee per night' },
		{ headerName: 'Other Fees PNT', field: 'otherFeePNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum', headerTooltip: 'Other fees per night (e.g. housekeeping, late checkout)' },
		{ headerName: 'Net PNT', field: 'revOwnerKBMPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum', headerTooltip: 'Owner amount plus KBM management fee per night' },
		// { headerName: 'Owner Amt TTL', field: 'ownerAmount', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
		{
			headerName: 'KBM Mgmt Fee PNT', field: 'kbmMgmtFeePNT', aggFunc: 'sum', headerTooltip: 'KBM management fee per night with commission rate in brackets',
			cellRenderer: (params: any) => {
				if (!params.data || params.data._spacer) return '';
				const fee = this.currencyCellRendererUSD({ value: params.value });
				const pct = params.data.revFeesPCT != null ? ` (${params.data.revFeesPCT}%)` : '';
				return fee + pct;
			},
		},
		{ headerName: 'Name', field: 'guestLastName', cellRenderer: params => this.getReservationLink(params),
			valueGetter: params => {
				if (params.node?.rowPinned) return '';
				const guestLastName = params?.data?.guestLastName;
				if (!guestLastName || guestLastName.trim() === '.' || guestLastName.trim() === '') {
				  return 'NEED NAME';
				}
				return guestLastName;
			  },
			  aggFunc: (params) => {
				const values = params.values;
				// Filter out "NEED NAME" entries from the values
				const filteredValues = values.filter(value => value !== 'NEED NAME');
				return filteredValues.length > 0 ? '' : '';
			  }
		 },
		{ headerName: 'Type', field: 'resStatus', cellRenderer: params => this.getReservationType(params),
      cellStyle: (params) => this.getColorByReservationType(params)},
		{ headerName: 'Agent', field: 'soldBy', },
		{
			headerName: 'Channel', field: 'refSrcId', width: 60, sortable: true, autoHeight: true,
			cellRenderer: params => this.displayChannelPicture(params),
			filterValueGetter: (params) => {
				// This custom filter will map the filter to the label based on refSrcImages
				const refSrcId = params.data.refSrcId;
				const channel = this.constantService.refSrcImages.find(item => item.value === refSrcId);
				return channel ? channel.label : refSrcId;
			  }
		},
		{
			headerName: 'Source Context', field: 'referralSourceContext', sortable: true,
			cellRenderer: params => this.constantService.getReferralSourceContextLabel(params.value),
		},
	];

	gridOptions: GridOptions = {
		rowData: this.resRevMaster,
		columnDefs: this.columnDefs,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,
		tooltipShowDelay: 100,
		tooltipHideDelay: 2147483647,
		domLayout: 'autoHeight',

		// Keep the blank spacer row pinned to the bottom after every sort.
		// All other rows sort normally; only the _spacer row is relocated.
		postSortRows: (params) => {
			const rows = params.nodes;
			const idx = rows.findIndex(n => n.data?._spacer);
			if (idx > -1) rows.push(rows.splice(idx, 1)[0]);
		},

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,

		aggFuncs: {
			// this overrides the grids built-in avg function
			'showArrivalDate': params => {
				console.log(JSON.stringify(params.values));
				if (params.values[1]) {
					return params.values[1].checkInDate;
				}
			},
		},

		// Adding custom context menu
		getContextMenuItems: (params) => {
		const defaultItems = params.defaultItems;
		  let result = [
			// 'separator', // Add a separator if needed
			{
			  name: 'Public Website',
			  action: () => {
				console.log(params.node.data.shortTermRentalId);
				this.redirectToPublicSite(params.node.data.shortTermRentalId);
			  },
			//   icon: '<i class="fas fa-cogs"></i>' 
			},
			{
				name: 'Season Summary',
				action: () => {
				  console.log(params.node.data.shortTermRentalId);
				  this.redirectToSeasonSummary(params.node.data.shortTermRentalId);
				},
			  //   icon: '<i class="fas fa-cogs"></i>' 
			},
			{
				name: 'View This Reservation',
				action: () => {
				  const orderId = params.node.data?.orderId;
				  if (orderId) {
					const url = `https://admin.kbmhawaii.com/order/${orderId}`;
					window.open(url, '_blank'); // Opens in a new tab
				  } else {
					console.warn('No Order ID found for this row');
				  }
				},
			},
			{
				name: 'View Property Reservations',
				action: () => {
				  const propertyCode = params.node.data?.propertyCode;
				  if (propertyCode) {
					const url = `https://admin.kbmhawaii.com/reservations/property/${propertyCode}`;
					window.open(url, '_blank'); // Opens in a new tab
				  } else {
					console.warn('No Property Code found for this row');
				  }
				},
			  },
    			'separator',
		  ];
	  
		  // Merge custom and default items
  		  return [...result, ...defaultItems];
		}
	}


	// forms
	formLoading = false;


	// to hold the current search
	currentSearchForm: any;


	// data
	// resRevMaster: any[];
	resRevMasterByDay: any[];
	resRevTotal: any[];
	resRevTotalByDay: any[];
	resRevTotalByMonth: any[];
	resRevTotalByYear: any[];


	// search defaults
	defaultStartDate: Date
	defaultEndDate: Date
	defaultReservationStatuses: any;
	defaultShortTermRentalIds: any;

	getReservationType(params: any) {
		if (params.value) {
			if (params.value == "OP") {
				return "Guest"
			} else if (params.value == "OO") {
				return "Owner"
			} else if (params.value == "OG") {
				return "Owner Guest"
			} else if (params.value == "NA") {
				return "Maintenance"
			}
		}
	};

  getColorByReservationType(params: any){
    if (params.value) {
      if (params.value == "OP") {
        return { color: 'black', backgroundColor: "lightgrey" };
      } else if (params.value == "OO") {
        return { color: 'black', backgroundColor: "hotpink"};
      } else if (params.value == "OG") {
        return { color: 'black', backgroundColor: "lightpink"};
      } else if (params.value == "NA") {
        return { color: 'black', backgroundColor: "darkgray"};
      }
    }
  }

  /**
   * Redirect to Public website
   */
  redirectToPublicSite(shortTermRentalId:any)
  {
   let baseUrl = 'https://www.kbmresorts.com/vacation-rentals';
   if(shortTermRentalId != null)
   {
	 baseUrl = baseUrl + '/' + shortTermRentalId;
   }
   window.open(baseUrl, '_blank');
  }

  /**
   * Redirect to Season Summary
   */
  redirectToSeasonSummary(shortTermRentalId:any)
  {
   let baseUrl = '/yield-max/5/'+shortTermRentalId;
   const url = this.router.serializeUrl(
     this.router.createUrlTree([baseUrl])
     );
     window.open(url, '_blank');
  }

	displayChannelPicture(params: any) {
		if (params.value) {
			return "<img style='height: 16px; width: auto; object-fit:contain' src='" + this.constantService.refSrcImages.find(function(item) { return item.value == params.value })?.imgurl + "'>"
		}
	};

	getLocationName(params: any) {
		if (params.value) {
			return this.constantService.locations.find(function(item) {
				return item.locationId == params.value
			})?.name;
		}
	};

	getReservationLink(params: any) {
		if (params.value) {
			let url = "https://admin.kbmhawaii.com/order/" + params?.data?.orderId;
			return '<a href=' + url + ' target="_blank">' + params.value + '</a>'
		}
	};

	getRentedPercent(params: any) {
		return (params?.data?.numNightsTTL / params?.data?.numNtsInMonthTTL)
	}

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns(true);
	}

	getNtsAvailToRent(params: any) {
		let ntsAvailToRent = new Date(moment(params?.data?.date).year(), moment(params?.data?.date).month(), 0).getDate() - (params?.data?.numNtsOwnerTTL + params?.data?.numNtsOwnerGuestTTL + params?.data?.numNtsMaintTTL);
		console.log('ntsAvailToRent' + ntsAvailToRent);
		return ntsAvailToRent;
	}

	getDaysInMonth(month: number, year: number) {
		console.log('days ' + new Date(year, month, 0).getDate());
		return new Date(year, month, 0).getDate();
	}


	getYearFromDate(params: any) {
		return moment(params?.data?.saleDate).format('YYYY')
	}

	getMonthFromDate(params: any) {
		return moment(params?.data?.saleDate).format('MMM');
	}

	getDayFromDate(params: any) {
		return parseInt(moment(params?.data?.saleDate).format('DD'));
	}



	getGuestName(params: any) {
		if (params.data) {
			return moment(params?.data?.checkInDate).format('MM/DD/YY') + ' - ' + moment(params?.data?.checkOutDate).format('MM/DD/YY') + '   #' + params?.data?.reservationId + ' ' + params?.data?.guestLastName;
		}
		return '';
	}

	getStayDates(params: any) {
		if (params.data) {
			return params?.data?.checkInDate + ' - ' + params?.data?.checkInDate;
		}
		return '';
	}

	currencyCellRendererUSD(params: any) {
		if (params.value == null || isNaN(Number(params.value))) return '';
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		const formatted = inrFormat.format(params.value);
		if (params.value < 0) {
			return `<span style="color:#c0392b;">${formatted}</span>`;
		}
		return formatted;
	}

	percentCellRenderer(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'percent',
			minimumFractionDigits: 1,
			maximumFractionDigits: 1
		});
		return inrFormat.format(params.value);
	}

	fullDateCellRendererUSD(params: any) {
		if (params.data && params.value) {
			return moment(params.value).format('MM/DD/YY');
		}
		return '';
	}

	ngOnInit(): void {
		this.defaultStartDate = new Date();
		// this.defaultStartDate = new Date(this.defaultStartDate.getFullYear()-4, this.defaultStartDate.getMonth(), 1);
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 12, 0);

		this.defaultReservationStatuses = ['OP', 'OO', 'OG'];
		this.defaultShortTermRentalIds = [1];

		// ag-grid
		this.gridOptions.rowData = this.resRevMaster;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// Pivot
		// this.gridOptions.pivotMode = true;
		// this.gridOptions.pivotColumnGroupTotals= 'before';
		// this.gridOptions.pivotRowTotals = 'before';

		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}

	// Appends one blank row so the scrollbar covers it instead of the last real row.
	// resRevMaster is never mutated — all totals/calculations still use the original array.
	get gridData(): any[] {
		return this.resRevMaster?.length ? [...this.resRevMaster, { _spacer: true }] : [];
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['resRevMaster']) {
			this.setPinnedTotalRow();
		}
	}

	setPinnedTotalRow(): void {
		if (!this.resRevMaster?.length) {
			(this.gridApi as any)?.setPinnedBottomRowData([]);
			return;
		}
		const totals = this.resRevMaster.reduce((acc, row) => {
			acc.numNtsTTL += row.numNtsTTL || 0;
			acc.revGrossTTL += row.revGrossTTL || 0;
			acc.revGrossPNT += row.revGrossPNT || 0;
			acc.resortFeePNT += row.resortFeePNT || 0;
			acc.damageWaiverFeePNT += row.damageWaiverFeePNT || 0;
			acc.otherFeePNT += row.otherFeePNT || 0;
			acc.revOwnerKBMPNT += row.revOwnerKBMPNT || 0;
			acc.kbmMgmtFeePNT += row.kbmMgmtFeePNT || 0;
			// Revenue and Rate: use revOwnerKBMTTL/PNT (Owner Amt + KBM Fee, ex-tax)
			// to match the Total Room Rate and Average Room Rate KPIs. Exclude
			// composite properties (listingType=2) and zero-revenue rows.
			const isNotComposite = row.listingType != null ? row.listingType !== 2 : true;
			if ((row.resStatus === 'OP' || row.resStatus === 'OG') && isNotComposite && (row.revOwnerKBMPNT || 0) > 0) {
				acc.revOwnerKBMTTL += row.revOwnerKBMTTL || 0;
				acc._ratePNTSum += row.revOwnerKBMPNT;
				acc._ratePNTCount++;
			}
			return acc;
		}, {
			numNtsTTL: 0, revOwnerKBMTTL: 0, revGrossTTL: 0,
			revGrossPNT: 0, resortFeePNT: 0, damageWaiverFeePNT: 0,
			otherFeePNT: 0, revOwnerKBMPNT: 0, kbmMgmtFeePNT: 0,
			_ratePNTSum: 0, _ratePNTCount: 0
		});

		const pinnedRow = {
			saleDate: null,
			numNtsTTL: totals.numNtsTTL,
			revOwnerKBMTTL: totals.revOwnerKBMTTL,
			revOwnerKBMPNT: totals._ratePNTCount > 0 ? totals._ratePNTSum / totals._ratePNTCount : 0,
			revGrossTTL: totals.revGrossTTL,
			revGrossPNT: totals.revGrossPNT,
			resortFeePNT: totals.resortFeePNT,
			damageWaiverFeePNT: totals.damageWaiverFeePNT,
			otherFeePNT: totals.otherFeePNT,
			kbmMgmtFeePNT: totals.kbmMgmtFeePNT,
			revFeesPCT: null,
		};

		(this.gridApi as any)?.setPinnedBottomRowData([pinnedRow]);
	}

	ngAfterViewInit(): void {
		(this.gridApi as any)?.setColumnDefs(this.columnDefs);
	}

	onGridReady(grid: any): void {
		this.gridApi = grid.api;
		this.columnApi = grid.columnApi;
		if (this.resRevMaster?.length > 0) {
			this.setPinnedTotalRow();
		}
	}
	onFirstDataRendered(params: any): void {
		// skipHeader=true: size columns to data width only, letting wrapHeaderText handle the rest
		setTimeout(() => { this.columnApi?.autoSizeAllColumns(true); }, 5000);
	}

}
